import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { CallProvider } from "@/context/CallContext";
import Login from "@/pages/Login";
import Welcome from "@/pages/Welcome";
import Messages from "@/pages/Messages";
import VIP from "@/pages/VIP";
import Navaratna from "@/pages/Navaratna";
import PaymentResult from "@/pages/PaymentResult";
import Onboarding from "@/pages/Onboarding";
import Home from "@/pages/Home";
import StreamRoom from "@/pages/StreamRoom";
import GoLive from "@/pages/GoLive";
import Wallet from "@/pages/Wallet";
import Profile from "@/pages/Profile";
import Leaderboard from "@/pages/Leaderboard";
import CallRoom from "@/pages/CallRoom";
import Discover from "@/pages/Discover";
import AgencyDashboard from "@/pages/AgencyDashboard";
import Search from "@/pages/Search";
import Earnings from "@/pages/Earnings";
import DailyRewards from "@/pages/DailyRewards";
import Events from "@/pages/Events";
import MyFans from "@/pages/MyFans";
import LevelPage from "@/pages/LevelPage";
import Explore from "@/pages/Explore";
import Settings from "@/pages/Settings";
import Admin from "@/pages/admin/Admin";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen max-w-md mx-auto flex items-center justify-center">
        <div className="w-10 h-10 rounded-full border-2 border-pink-500 border-t-transparent animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (!user.onboarded) return <Navigate to="/onboarding" replace />;
  return children;
}

function OnboardGate({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (user.onboarded) return <Navigate to="/" replace />;
  return children;
}

function RootGate() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen max-w-md mx-auto flex items-center justify-center">
        <div className="w-10 h-10 rounded-full border-2 border-pink-500 border-t-transparent animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/welcome" replace />;
  if (!user.onboarded) return <Navigate to="/onboarding" replace />;
  return <Home />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CallProvider>
          <Toaster theme="dark" position="top-center" toastOptions={{ style: { background: "#131A2A", border: "1px solid rgba(230,184,76,0.25)", color: "#FFFFFF", boxShadow: "0 8px 30px rgba(0,0,0,0.4)" } }} />
          <Routes>
            <Route path="/welcome" element={<Welcome />} />
            <Route path="/messages" element={<Protected><Messages /></Protected>} />
            <Route path="/messages/:userId" element={<Protected><Messages /></Protected>} />
            <Route path="/vip" element={<Protected><VIP /></Protected>} />
            <Route path="/navaratna" element={<Protected><Navaratna /></Protected>} />
            <Route path="/payment-result" element={<Protected><PaymentResult /></Protected>} />
            <Route path="/login" element={<Login />} />
            <Route path="/onboarding" element={<OnboardGate><Onboarding /></OnboardGate>} />
            <Route path="/" element={<RootGate />} />
            <Route path="/stream/:id" element={<Protected><StreamRoom /></Protected>} />
            <Route path="/call/:id" element={<Protected><CallRoom /></Protected>} />
            <Route path="/discover" element={<Protected><Discover /></Protected>} />
            <Route path="/agency" element={<Protected><AgencyDashboard /></Protected>} />
            <Route path="/search" element={<Protected><Search /></Protected>} />
            <Route path="/go-live" element={<Protected><GoLive /></Protected>} />
            <Route path="/wallet" element={<Protected><Wallet /></Protected>} />
            <Route path="/profile" element={<Protected><Profile /></Protected>} />
            <Route path="/profile/:userId" element={<Protected><Profile /></Protected>} />
            <Route path="/leaderboard" element={<Protected><Leaderboard /></Protected>} />
            <Route path="/earnings" element={<Protected><Earnings /></Protected>} />
            <Route path="/rewards" element={<Protected><DailyRewards /></Protected>} />
            <Route path="/events" element={<Protected><Events /></Protected>} />
            <Route path="/fans" element={<Protected><MyFans /></Protected>} />
            <Route path="/level" element={<Protected><LevelPage /></Protected>} />
            <Route path="/explore" element={<Protected><Explore /></Protected>} />
            <Route path="/settings" element={<Protected><Settings /></Protected>} />
            <Route path="/admin/*" element={<Admin />} />
          </Routes>
          </CallProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
